import { render } from "./RegistroFinalView.vue?vue&type=template&id=45e581e4&scoped=true"
import script from "./RegistroFinalView.vue?vue&type=script&lang=js"
export * from "./RegistroFinalView.vue?vue&type=script&lang=js"

import "./RegistroFinalView.vue?vue&type=style&index=0&id=45e581e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e581e4"]])

export default __exports__